<template>
  <div class="bq-cms-wrap cms-wrap"></div>
</template>

<script>

export default {
  name: "BQCms",
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped></style>